import { useLanguage } from '../contexts/LanguageContext';
import { PillToggle } from './PillToggle';

// FR / EN language toggle (flag + code), shown in the sidebar.
const LANGS = [
  { value: 'fr', icon: '🇫🇷', label: 'FR' },
  { value: 'en', icon: '🇬🇧', label: 'EN' },
] as const;

export function LangToggle() {
  const { language, setLanguage } = useLanguage();
  return <PillToggle options={LANGS} value={language as 'fr' | 'en'} onChange={setLanguage} />;
}
